import script from "./BVVerificationReport.vue?vue&type=script&setup=true&lang=js"
export * from "./BVVerificationReport.vue?vue&type=script&setup=true&lang=js"

import "./BVVerificationReport.vue?vue&type=style&index=0&id=68860051&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68860051"]])

export default __exports__